// extracted by mini-css-extract-plugin
export default {"button":"_1YbPm","container":"B5nU8","sticky":"_2xTgU","withGradientBackground":"Nm2V5","hidden":"_ID0O"};